<div class="bg-(--color-secondary) rounded-2xl p-6 text-white">
  <div class="flex flex-col items-center gap-2">
    <div class="w-12 h-12 rounded-xl bg-(--color-main-20) flex items-center justify-center">
      <i class="fa-solid fa-envelope text-xl text-(--color-main)"></i>
    </div>
    <h3 class="font-bold text-xl text-(--color-main)">ابدأ التعاقد</h3>
    <p class="text-sm text-center opacity-80">أدخل رقم الهاتف للبدء في رحلتك التعاقدية</p>
  </div>

  <form class="mt-5" [formGroup]="form" (ngSubmit)="goOtp()">
    <label class="block text-sm opacity-90">رقم الهاتف</label>

    <input
    #phone
      formControlName="phone"
      inputmode="numeric"
      dir="ltr"
      class="mt-2 w-full rounded-lg bg-transparent border border-(--color-main) px-3 py-2 outline-none text-sm font-normal text-white/60 placeholder:text-white/40"
      placeholder="+012xxxxxxxxx"
    />

    @if (form.controls.phone.touched && form.controls.phone.invalid) {
      <div class="mt-2 text-sm text-red-200">اكتب رقم صحيح (مثال: +012xxxxxxxxx)</div>
    }

    <div class="text-center">
      <button
        type="submit"
        [disabled]="form.invalid || flow.loading()"
        class="inline-flex items-center h-12 gap-2 px-16 mt-4 font-bold transition-all duration-300 rounded-lg"
        [ngClass]="
          form.invalid || flow.loading()
            ? 'bg-(--color-main-20) text-white/60 cursor-not-allowed'
            : 'bg-(--color-main) text-(--color-secondary) cursor-pointer hover:bg-(--color-main-20) hover:text-(--color-main)'
        "
      >
        <span>{{ flow.loading() ? 'جاري الإرسال...' : 'أكتشف الفرص الزراعية' }}</span>
        <span class="text-xl">←</span>
      </button>
    </div>
  </form>
</div>
